import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/base/baseline.css";
import "../../styles/pages/services.css";

import "../../styles/module/collaborate.css";
import "../../styles/module/carousel.css";

import WhyUs from "../module/Why-Us";
import WebMobileAppSlider from "../module/WebMobileApp-Slider";
import Collaborate from "../module/Collaborate";
import FAQs from "../module/FAQs";
import Clients from "../module/Clients";

import bg2 from "../../assets/images/img/bg-2.webp";
// import bg3 from "../../assets/images/img/bg-3.svg";
import arrow from "../../assets/images/img/downarrow.webp";

export default function WebMobileApp() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" className="" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section section__oferta">
          {/* <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          /> */}
          <div className="container oferta">
            <h5 className="drop-from-top" id="scroll">
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>service</font>
              </font>
            </h5>
            <div className="title drop-from-top">
              <h2 style={{ marginBottom: "30px" }}>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    Your Digital Solution, Crafted for Performance and Impact
                  </font>
                </font>
              </h2>
            </div>
            <div className="description container__text">
              <p className="slide-from-left">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    We design and develop web and mobile applications that go
                    beyond aesthetics — they are built to perform, scale, and
                    engage. With tailored UI/UX design, cross-platform
                    compatibility, and a focus on speed and responsiveness, our
                    apps deliver seamless user experiences that drive real
                    business outcomes. From progressive web apps to optimized
                    performance, every solution is engineered to meet your
                    unique needs.
                  </font>
                </font>
              </p>
              <p className="slide-from-right">
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit" }}>
                    More than just code and features, our applications are built
                    to create competitive advantages. By integrating advanced
                    interactive elements and ensuring smooth functionality
                    across all devices, we help you attract and retain users,
                    elevate your brand, and stay ahead in a fast-evolving
                    digital landscape.
                  </font>
                </font>
              </p>
            </div>
          </div>
        </div>
        <WhyUs hideBackgroundImage={true} />
        <WebMobileAppSlider />
        <Collaborate />
        <FAQs />

        <Clients />
      </div>
    </>
  );
}
